import React from 'react'
import PropTypes from 'prop-types'
import { animated, useSpring } from 'react-spring'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { EXPORT_CLASSNAME } from '../../../../constants'

const useStyles = makeStyles((theme) => ({
  frameLayoutContainer: {
    backgroundColor: ({ expanded }) => expanded ? 'var(--tc-frame-bg-normal)' : 'var(--tc-frame-bg-expanded)',
    margin: 'inherit',
    padding: ({ expanded }) => expanded ? '3.8rem 0 0' : '3.8rem 2.5rem 0rem',
    position: 'absolute',
    width: '100%',
    height: '100%',
    minHeight: '100%',
    top: 0,
    willChange: 'padding, border-color, background-color',
    transition: 'padding .1s ease-in-out, border-color .1s ease-in-out, background-color .2s ease-in-out',

    '.av-popup-frame &': {
      paddingTop: '.5rem'
    }
  },
  paper: ({ expanded }) => ({
    height: expanded ? 'calc(100%)' : 'calc(100% - 1rem)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    backgroundColor: 'var(--tc-frame-bg-normal)',
    border: 'var(--border-normal)',
    borderRadius: expanded ? '0' : 'var(--border-radius-lg)'
  }),
  frameView: {
    marginTop: ({ expanded }) => expanded ? '-.8rem' : 0,
    height: '100%',
    overflow: 'auto',
    overflowX: 'hidden',
    padding: ({ expanded }) => expanded ? '0 1rem' : '1rem',
    '&::-webkit-scrollbar': {
      width: '1em',
      height: '1em',
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 'var(--border-radius-lg)',
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      visibility: 'visible',
      borderRadius: 'var(--border-radius-lg)',
      backgroundColor: 'var(--color-neutral-600)',
      border: '3px solid white'
    }
  }
}))

const AdvisorViewFrameLayout = ({ children, expand, frameStyles }) => {
  const classes = useStyles({ expanded: expand })

  const pageSprings = useSpring({
    from: { left: 100, opacity: 0 },
    to: { left: 0, opacity: 1 },
    leave: { left: -100, opacity: 0 }
  })

  return (
    <div className={classes.frameLayoutContainer}>
      <animated.div className={classes.paper} style={pageSprings}>
        <div
          className={clsx(classes.frameView, EXPORT_CLASSNAME)}
          style={frameStyles}
        >
          {children}
        </div>
      </animated.div>
    </div>
  )
}

AdvisorViewFrameLayout.propTypes = {
  children: PropTypes.node,
  expand: PropTypes.bool,
  frameStyles: PropTypes.object
}

AdvisorViewFrameLayout.defaultProps = {
  expand: false,
  frameStyles: {}
}

export default AdvisorViewFrameLayout
